export const REPORT_EXPORT_POLL_MS = 2000;

export const REPORT_EXPORT_POLL_MAX_CONSECUTIVE_ERRORS = 3;

export const REPORT_EXPORT_KEYS = {
  failed: 'app.reports.allDemands.export.failed',
  startFailed: 'app.reports.allDemands.export.startFailed',
  downloadFailed: 'app.reports.allDemands.export.downloadFailed',
  fileGone: 'app.reports.allDemands.export.fileGone',
} as const;
